export const SSO_INTEGRATION_KEY_BASE = 'sso_integration';
export const SsoIntegrationKeyFactory = {
    all: () => [SSO_INTEGRATION_KEY_BASE],
    byWorkspaceId: (workspaceId) => [
        SSO_INTEGRATION_KEY_BASE,
        workspaceId,
    ],
};
